let lenis = null;

export const setLenis = (instance) => {
    lenis = instance;
};

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenis) {
        // Re-measure first: after a page change Lenis may still hold the old page height.
        lenis.resize();
        lenis.scrollTo(el, { offset: -84, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
};

/* Jump to the top of the page. Goes through Lenis when it's active, because
   Lenis would otherwise animate straight back to its previous position. */
export const scrollToTop = () => {
    if (lenis) {
        lenis.scrollTo(0, { immediate: true, force: true });
    }
    window.scrollTo(0, 0);
};
